export default __webpack_public_path__ + "static/media/logo.84dc18d1.jpeg";